import './App.css';
import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from './screens/Login';
import UserUploadCsv from './screens/userCsvUpload/UserUploadCsv';
import CsvUserDayEarnings from './screens/userCsvUpload/CsvUserDayEarnings';
import UploadCsvUserStat from './screens/UploadCsvUserStat';
import UserPartnerBlocked from './screens/UserPartnerBlocked';
import SpinWheelRewards from './screens/SpinWheelRewards';
import Video from './screens/Video';
import AllVideos from './screens/AllVideos';
import EditVideo from './screens/EditVideo';
import StreakData from './screens/StreakData';
import VideoStat from './screens/VideoStat';
import UserUniqueLogs from './screens/UserUniqueLogs';
import UserEventLogs from './screens/UserEventLogs';
import UserPartnerLimitData from './screens/UserPartnerLimitData';
import DeviceLoginInfo from './screens/DeviceLoginInfo';
import DailyLoginInfo from './screens/DailyLoginInfo';
import AppImages from './screens/AppImages';
import UserSurveyIpStat from './screens/UserSurveyIpStat';
import PostBack from './screens/postback/PostBack';
import OfferCountryAvailability from './screens/OfferCountryAvailability';
import AllCustomBanner from './screens/AllCustomBanner';
import AllBannerUserActivity from './screens/AllBannerUserActivity';
import CreateCustomBanner from './screens/CreateCustomBanner';
import EditCustomBanner from './screens/EditCustomBanner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import FinancialDashboard from './screens/financialDashboard/FinancialDashboard';
import RevenueAnalytics from './screens/revenueDashboard/RevenueAnalytics';
import UserCohortAnalytics from './screens/userAnalytics/UserCohortAnalytics';
import PartnerAnalytics from './screens/partnerAnalytics/PartnerAnalytics';

const AddOffer = React.lazy(() => import("./screens/AddOffer"))
const AllOfferAvailability = React.lazy(() => import("./screens/AllOfferAvailability"))
const Announcement = React.lazy(() => import('./screens/Announcement'));
const AddAnnouncement = React.lazy(() => import('./screens/AddAnnouncement'));
const AnnouncementUserDetails = React.lazy(() => import('./screens/AnnouncementUserDetails'));
const CustomAnnouncementCsv = React.lazy(() => import('./screens/CustomAnnouncementCsv'));

const UserOfPartnerEarning = React.lazy(() => import('./screens/userCsvUpload/UserOfPartnerEarning'));
const CsvUploadPartnerEarning = React.lazy(() => import('./screens/userCsvUpload/CsvUploadPartnerEarning'));
const UserEarning = React.lazy(() => import('./screens/userCsvUpload/UserEarning'));
const OfferStats = React.lazy(() => import('./screens/OfferStats'));
const UserOffer = React.lazy(() => import('./screens/UserOffer'));
const ProfilerInfo = React.lazy(() => import('./screens/ProfilerInfo'));
const DevicesInfo = React.lazy(() => import('./screens/DevicesInfo'));

const Home = React.lazy(() => import('./screens/Home'));
const Profile = React.lazy(() => import('./screens/Profile'));
const Categories = React.lazy(() => import('./screens/Categories'));
// const Offer = React.lazy(() => import('./screens/Offer'));
// const AllOffers = React.lazy(() => import('./screens/AllOffers'));
const EditOffer = React.lazy(() => import('./screens/EditOffer'));
const Partners = React.lazy(() => import('./screens/Partners'));
const UserTransaction = React.lazy(() => import('./screens/UserTransaction'));
const UserEvent = React.lazy(() => import('./screens/UserEvent'))
const SingleOffer = React.lazy(() => import('./screens/SingleOffer'));
const AddBlogs = React.lazy(() => import('./screens/AddBlogs'));
const AllBlogs = React.lazy(() => import('./screens/AllBlogs'));
const EditBlog = React.lazy(() => import('./screens/EditBlog'));
const Admins = React.lazy(() => import('./screens/Admins'));
const StaticOffers = React.lazy(() => import('./screens/StaticOffers'));
const PartnerOffer = React.lazy(() => import('./screens/PartnerOffer'));
const LeaderBoard = React.lazy(() => import('./screens/LeaderBoard'));
const MetaConfig = React.lazy(() => import('./screens/MetaConfig'));
const AddPartner = React.lazy(() => import('./screens/partner/AddPartner'));
const NotificationCampaign = React.lazy(() => import('./screens/NotificationCampaign'));
const DeepLinkManagement = React.lazy(() => import('./screens/DeepLinkManagement'));
const EditPartner = React.lazy(() => import('./screens/partner/EditPartner'));
const PartnerDetail = React.lazy(() => import('./screens/partner/PartnerDetail'));
const PaymentMode = React.lazy(() => import('./screens/PaymentMode'));
const AdminLogs = React.lazy(() => import('./screens/AdminLogs'));
const ReferalLeaderBoard = React.lazy(() => import('./screens/ReferalLeaderBoard'));
const WinnerLeaderBoard = React.lazy(() => import('./screens/WinnerLeaderBoard'));
const EarningLeaderBoard = React.lazy(() => import('./screens/EarningLeaderBoard'));
const AllUsers = React.lazy(() => import('./screens/AllUsers'));
const PendingEarning = React.lazy(() => import('./screens/PendingEarning'));
const Transaction2 = React.lazy(() => import('./screens/Transaction2'));
const Challenge = React.lazy(() => import('./screens/Challenge'));
const AllChallenge = React.lazy(() => import('./screens/AllChallenge'));
const EditChallenge = React.lazy(() => import('./screens/EditChallenge'));
const UserLogs = React.lazy(() => import('./screens/UserLogs'));
const UserPartnerData = React.lazy(() => import('./screens/UserPartnerData'));
const ReferLinkStat = React.lazy(() => import('./screens/ReferLinkStat'));
const InvalidUrlPage = React.lazy(() => import('./screens/InvalidUrlPage'));
const ConfigurationInfo = React.lazy(() => import('./screens/ConfigurationInfo'));
const OneUserTask = React.lazy(() => import('./screens/OneUserTask'));
const MultiPageData = React.lazy(() => import('./screens/MultiPageData'));
const AllMultiPageData = React.lazy(() => import('./screens/AllMultiPageData'));
const EditMultiPageData = React.lazy(() => import('./screens/EditMultiPageData'));
const SingleUserAllTask = React.lazy(() => import('./screens/SingleUserAllTask'));
const TaskLogs = React.lazy(() => import('./screens/TaskLogs'));
const RoomCards = React.lazy(() => import('./screens/RoomCards'));
const CreateRoomCard = React.lazy(() => import('./screens/CreateRoomCard'));
const EditRoomCard = React.lazy(() => import('./screens/EditRoomCard'));
const LudoAnalytics = React.lazy(() => import('./screens/LudoAnalytics'));
const Loader = React.lazy(() => import('../src/helperComponent/Loader'));
const RatingsManagement = React.lazy(() => import("./screens/RatingsManagement"));
const ErrorLogs = React.lazy(() => import("./screens/ErrorLogs"));
const PostbackErrors = React.lazy(() => import("./screens/PostbackErrors"));
const Options = React.lazy(() => import('./screens/Options'));
const Question = React.lazy(() => import('./screens/Question'));
const SurveyPartner = React.lazy(() => import('./screens/SurveyPartner'));
const UserSurveyStatus = React.lazy(() => import('./screens/UserSurveyStatus'));
const CreatePartnerLeaderboard = React.lazy(() => import('./screens/CreatePartnerLeaderboard'));
const OptStats = React.lazy(() => import('./screens/OtpStats'))
const RegisteredUserSurveyStats = React.lazy(() => import('./screens/RegisteredUserSurveyStats'));
const InvoiceManagement = React.lazy(() => import('./screens/InvoiceManagement'));
const RoomContests = React.lazy(() => import('./screens/RoomContests'));
const BulkActivity = React.lazy(() => import('./screens/BulkActivity'));
const UserProfileStats = React.lazy(() => import('./screens/UserProfileStats'));
const MatchmakingQueues = React.lazy(() => import('./screens/MatchmakingQueues'));
const EmailTemplates = React.lazy(() => import('./screens/EmailTemplates'));
const EmailTemplateEditor = React.lazy(() => import('./screens/EmailTemplateEditor'));
const ReferThroughStats = React.lazy(() => import('./screens/ReferThroughStats'));
const PublishersList = React.lazy(() => import('./screens/publisher/PublishersList'));
const CreatePublisher = React.lazy(() => import('./screens/publisher/CreatePublisher'));
const EditPublisher = React.lazy(() => import('./screens/publisher/EditPublisher'));
const PublisherDetail = React.lazy(() => import('./screens/publisher/PublisherDetail'));
const PublisherClicks = React.lazy(() => import('./screens/publisher/PublisherClicks'));

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState('')
  const queryClient = new QueryClient();

  useEffect(() => {
    const jwtToken = localStorage.getItem('JWT');
    if (jwtToken) {
      setIsAuthenticated(true);
      const admindata = localStorage.getItem("admin");
      const adminArray = JSON.parse(admindata);
      setRole(adminArray?.role)
    }

  }, []);
  function ProtectedRoute({ children }) {
    const jwtToken = localStorage.getItem('JWT');

    if (!jwtToken) {
      return <Navigate to="/login" />;
    }
    return children;
  }


  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Suspense>
            <Routes>
              <Route exact path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/uploadUserCsv" element={<ProtectedRoute><UserUploadCsv /></ProtectedRoute>} />
              <Route path="/admin/csv-user-day-earnings" element={<ProtectedRoute><CsvUserDayEarnings /></ProtectedRoute>} />
              {role == 3 && <Route path="/admins" element={<ProtectedRoute><Admins /></ProtectedRoute>} />}
              <Route path="/login" element={isAuthenticated ? <Home /> : <Login />} />
              <Route path="/profile" element={<ProtectedRoute><Profile /> </ProtectedRoute>} />
              <Route path="/partner-detail/:id" element={<ProtectedRoute><PartnerDetail /></ProtectedRoute>} />
              <Route path="/partners" element={<ProtectedRoute> <Partners /> </ProtectedRoute>} />
              <Route path="/editpartner/:id" element={<ProtectedRoute><EditPartner /></ProtectedRoute>} />
              <Route path="/offer/:id" element={<ProtectedRoute><SingleOffer /></ProtectedRoute>} />
              <Route path="/AddPartner" element={<ProtectedRoute><AddPartner /></ProtectedRoute>} />
              <Route path="/NotificationCampaign" element={<ProtectedRoute><NotificationCampaign /></ProtectedRoute>} />
              <Route path="/DeepLinkManagement" element={<ProtectedRoute><DeepLinkManagement /></ProtectedRoute>} />
              <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
              <Route path="/Home" element={<ProtectedRoute> <Home /> </ProtectedRoute>} />
              {/* <Route path="/allOffers" element={<ProtectedRoute> <AllOffers /></ProtectedRoute>} /> */}
              <Route path="/allBlogs" element={<ProtectedRoute><AllBlogs /> </ProtectedRoute>} />
              <Route path="/addBlog" element={<ProtectedRoute> <AddBlogs /> </ProtectedRoute>} />
              <Route path="/editBlog" element={<ProtectedRoute>  <EditBlog /> </ProtectedRoute>} />
              <Route path="/transaction" element={<ProtectedRoute>  <Transaction2 /> </ProtectedRoute>} />
              <Route path="/pendingearning" element={<ProtectedRoute>  <PendingEarning /> </ProtectedRoute>} />
              <Route path="/staticOffers" element={<ProtectedRoute> <StaticOffers /> </ProtectedRoute>} />
              <Route path="/partnerOffer/:id" element={<ProtectedRoute>  <PartnerOffer /> </ProtectedRoute>} />
              <Route path="/metaconfig" element={<ProtectedRoute> <MetaConfig /> </ProtectedRoute>} />
              <Route path="/leaderboard" element={<ProtectedRoute>  <LeaderBoard /> </ProtectedRoute>} />
              <Route path="/referalleaderboard" element={<ProtectedRoute>  <ReferalLeaderBoard /> </ProtectedRoute>} />
              <Route path="/winnerleaderboard" element={<ProtectedRoute>  <WinnerLeaderBoard /> </ProtectedRoute>} />
              <Route path="/earningleaderboard" element={<ProtectedRoute>  <EarningLeaderBoard /> </ProtectedRoute>} />
              <Route path="/paymentMode" element={<ProtectedRoute> <PaymentMode /> </ProtectedRoute>} />
              <Route path="/AdminLogs/:adminID" element={<ProtectedRoute> <AdminLogs /> </ProtectedRoute>} />
              <Route path='/challenge' element={<ProtectedRoute>  <Challenge /> </ProtectedRoute>} />
              <Route path='/allchallenge' element={<ProtectedRoute>  <AllChallenge /> </ProtectedRoute>} />
              <Route path='/editchallenge/:id' element={<ProtectedRoute> <EditChallenge /> </ProtectedRoute>} />
              <Route path='/userLogs/:id' element={<ProtectedRoute>  <UserLogs /> </ProtectedRoute>} />
              <Route path='/user/partnerData/:id' element={<ProtectedRoute>  <UserPartnerData /> </ProtectedRoute>} />
              <Route path='/referlinkstat' element={<ProtectedRoute>  <ReferLinkStat /> </ProtectedRoute>} />
              <Route path='/configurationInfo' element={<ProtectedRoute>  <ConfigurationInfo /> </ProtectedRoute>} />
              <Route path='/oneUserTask/:id' element={<ProtectedRoute> <OneUserTask /> </ProtectedRoute>} />
              <Route path='/multiPageData' element={<ProtectedRoute>  <MultiPageData /> </ProtectedRoute>} />
              <Route path='/allmultiPageData' element={<ProtectedRoute>  <AllMultiPageData /> </ProtectedRoute>} />
              <Route path='/editmultiPageData/:id' element={<ProtectedRoute>  <EditMultiPageData /> </ProtectedRoute>} />
              <Route path='/singleUserAllTask/:id' element={<ProtectedRoute>  <SingleUserAllTask /> </ProtectedRoute>} />
              <Route path='/taskLogs/:id' element={<ProtectedRoute> <TaskLogs /> </ProtectedRoute>} />
              <Route path='/deviceInfo' element={<ProtectedRoute> <DevicesInfo /> </ProtectedRoute>} />
              <Route path='/userCsvDataStat' element={<ProtectedRoute> <UploadCsvUserStat /> </ProtectedRoute>} />
              <Route path='/userPartnerBlocked' element={<ProtectedRoute> <UserPartnerBlocked /> </ProtectedRoute>} />
              <Route path='/spinWheelRewardsData' element={<ProtectedRoute><SpinWheelRewards /> </ProtectedRoute>} />
              <Route path='/allVideo' element={<ProtectedRoute><AllVideos /> </ProtectedRoute>} />
              <Route path='/video' element={<ProtectedRoute><Video /> </ProtectedRoute>} />
              <Route path='/editVideo/:id' element={<ProtectedRoute><EditVideo /></ProtectedRoute>} />
              <Route path='/streakData' element={<ProtectedRoute><StreakData /></ProtectedRoute>} />
              <Route path='/dailyLogingData' element={<ProtectedRoute><UserUniqueLogs /></ProtectedRoute>} />
              <Route path='/videoStat' element={<ProtectedRoute><VideoStat /></ProtectedRoute>} />
              <Route path='/UserPartnerLimitData' element={<ProtectedRoute><UserPartnerLimitData /></ProtectedRoute>} />
              <Route path='/announcement' element={<ProtectedRoute><Announcement /></ProtectedRoute>} />
              <Route path='/addAnnouncement' element={<ProtectedRoute><AddAnnouncement /></ProtectedRoute>} />
              <Route path='/announcementUserDetails' element={<ProtectedRoute><AnnouncementUserDetails /></ProtectedRoute>} />
              <Route path='/custom-announcement-csv' element={<ProtectedRoute><CustomAnnouncementCsv /></ProtectedRoute>} />
              <Route path='/uploadCsv-partnerEarning-users/:id' element={<ProtectedRoute><UserOfPartnerEarning /></ProtectedRoute>} />
              <Route path='/uploadCsvPartnerEarning' element={<ProtectedRoute><CsvUploadPartnerEarning /></ProtectedRoute>} />
              <Route path='/userEarningn' element={<ProtectedRoute><UserEarning /></ProtectedRoute>} />
              <Route path='/offerStats' element={<ProtectedRoute><OfferStats /></ProtectedRoute>} />
              <Route path='/UserOffer' element={<ProtectedRoute><UserOffer /></ProtectedRoute>} />
              {/* <Route path='/profilerInfo' element={<ProtectedRoute><ProfilerInfo /></ProtectedRoute>} /> */}
              <Route path="/loginInfo" element={<ProtectedRoute> <DeviceLoginInfo /> </ProtectedRoute>} />
              <Route path='/eventLogData' element={<ProtectedRoute><UserEventLogs /></ProtectedRoute>} />
              <Route path='/dialyLoginInfo' element={<ProtectedRoute><DailyLoginInfo /></ProtectedRoute>} />
              <Route path='/add/app/images' element={<ProtectedRoute><AppImages /></ProtectedRoute>} />
              <Route path='/user/survey/ip/stat' element={<ProtectedRoute><UserSurveyIpStat /></ProtectedRoute>} />
              <Route path='/allPostBack' element={<ProtectedRoute><PostBack /></ProtectedRoute>} />
              <Route path='/offerAvailableInCountry/:id' element={<ProtectedRoute><OfferCountryAvailability /></ProtectedRoute>} />
              <Route path='/countryOffers' element={<ProtectedRoute><AllOfferAvailability /></ProtectedRoute>} />
              <Route path='/RatingsManagement' element={<ProtectedRoute><RatingsManagement /></ProtectedRoute>} />

              {/* Users */}
              <Route path="/users" element={<ProtectedRoute><AllUsers /></ProtectedRoute>} />
              <Route path="/users/transaction/:id" element={<ProtectedRoute>  <UserTransaction /> </ProtectedRoute>} />
              <Route path="/users/event/:userId" element={<ProtectedRoute>  < UserEvent /> </ProtectedRoute>} />

              {/* Offers Area */}
              <Route path='/addOffer' element={<ProtectedRoute><AddOffer /></ProtectedRoute>} />
              <Route path="/editOffer" element={<ProtectedRoute> <EditOffer /> </ProtectedRoute>} />

              {/* Custom banner */}
              <Route path='/allcustomBanner' element={<ProtectedRoute><AllCustomBanner /></ProtectedRoute>} />
              <Route path='/bannerUserActivity' element={<ProtectedRoute><AllBannerUserActivity /></ProtectedRoute>} />
              <Route path='/createCustomBanner' element={<ProtectedRoute><CreateCustomBanner /></ProtectedRoute>} />
              <Route path='/editCustomBanner' element={<ProtectedRoute><EditCustomBanner /></ProtectedRoute>} />
              {/* question flow Cards */}
              <Route path='/all/option' element={<ProtectedRoute><Options /></ProtectedRoute>} />
              <Route path='/all/question' element={<ProtectedRoute><Question /></ProtectedRoute>} />
              <Route path='/all/survey' element={<ProtectedRoute><SurveyPartner /></ProtectedRoute>} />
              <Route path='/all/survey/user/stats' element={<ProtectedRoute><UserSurveyStatus /></ProtectedRoute>} />
              <Route path='/register/user/stats' element={<ProtectedRoute><RegisteredUserSurveyStats /></ProtectedRoute>} />
              {/* room Cards */}
              <Route path='/admin/room-cards' element={<ProtectedRoute><RoomCards /></ProtectedRoute>} />
              <Route path='/admin/room-cards/create' element={<ProtectedRoute><CreateRoomCard /></ProtectedRoute>} />
              <Route path='/admin/room-cards/edit/:id' element={<ProtectedRoute><EditRoomCard /></ProtectedRoute>} />
              <Route path='/admin/ludo-analytics' element={<ProtectedRoute><LudoAnalytics /></ProtectedRoute>} />
              <Route path='/admin/error-details' element={<ProtectedRoute><ErrorLogs /></ProtectedRoute>} />
              <Route path='/admin/PostbackErrors' element={<ProtectedRoute><PostbackErrors /></ProtectedRoute>} />
              {/* Email Templates */}
              <Route path='/admin/email-templates' element={<ProtectedRoute><EmailTemplates /></ProtectedRoute>} />
              <Route path='/admin/email-templates/new' element={<ProtectedRoute><EmailTemplateEditor /></ProtectedRoute>} />
              <Route path='/admin/email-templates/edit/:name' element={<ProtectedRoute><EmailTemplateEditor /></ProtectedRoute>} />
              <Route path='/admin/PartnerLeaderboard' element={<ProtectedRoute><CreatePartnerLeaderboard /></ProtectedRoute>} />
              <Route path='/admin/otp/stats' element={<ProtectedRoute><OptStats /></ProtectedRoute>} />
              {/* Invoice */}
              <Route path='/admin/invoice' element={<ProtectedRoute><InvoiceManagement /></ProtectedRoute>} />
              <Route path='/admin/finance' element={<ProtectedRoute><FinancialDashboard /> </ProtectedRoute>} />
              <Route path='/admin/revenue' element={<ProtectedRoute><RevenueAnalytics /> </ProtectedRoute>} />
              <Route path='/admin/userAnalytics' element={<ProtectedRoute><UserCohortAnalytics /> </ProtectedRoute>} />
              <Route path='/admin/partnerAnalytics' element={<ProtectedRoute><PartnerAnalytics /> </ProtectedRoute>} />
              <Route path='/admin/room-card-details' element={<ProtectedRoute><RoomContests /> </ProtectedRoute>} />
              <Route path='/admin/bulk/activity' element={<ProtectedRoute> <BulkActivity /> </ProtectedRoute>} />
              <Route path='/admin/user-profile/stats' element={<ProtectedRoute> <UserProfileStats /> </ProtectedRoute>} />
              <Route path='/admin/redis/match-making' element={<ProtectedRoute> <MatchmakingQueues /> </ProtectedRoute>} />
              <Route path='/admin/refer-through/stats' element={<ProtectedRoute><ReferThroughStats /></ProtectedRoute>} />
              {/* Publisher Distribution */}
              <Route path='/publishers' element={<ProtectedRoute><PublishersList /></ProtectedRoute>} />
              <Route path='/publishers/new' element={<ProtectedRoute><CreatePublisher /></ProtectedRoute>} />
              <Route path='/publishers/:id/edit' element={<ProtectedRoute><EditPublisher /></ProtectedRoute>} />
              <Route path='/publishers/:id/clicks' element={<ProtectedRoute><PublisherClicks /></ProtectedRoute>} />
              <Route path='/publishers/:id' element={<ProtectedRoute><PublisherDetail /></ProtectedRoute>} />
              <Route path="*" element={<InvalidUrlPage />} />
            </Routes>
          </Suspense >

        </Router>
      </QueryClientProvider>
    </>

  );
}

export default App;
